var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M24.124 0L8.099 16.025 2.007 9.933 0 11.94l8.1 8.1L26.131 2.007z","fill":"#faffff"}));
}

Checkmark.defaultProps = {"width":"26.131","height":"20.039","xmlnsV":"https://vecta.io/nano"};

module.exports = Checkmark;

Checkmark.default = Checkmark;
